import { render } from "./StreamOverviewStats.vue?vue&type=template&id=bfe5289c&scoped=true"
import script from "./StreamOverviewStats.vue?vue&type=script&lang=js"
export * from "./StreamOverviewStats.vue?vue&type=script&lang=js"

import "./StreamOverviewStats.vue?vue&type=style&index=0&id=bfe5289c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe5289c"],['__file',"src/views/StreamsDash/StreamOverviewStats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfe5289c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfe5289c', __exports__)) {
    api.reload('bfe5289c', __exports__)
  }
  
  module.hot.accept("./StreamOverviewStats.vue?vue&type=template&id=bfe5289c&scoped=true", () => {
    api.rerender('bfe5289c', render)
  })

}


export default __exports__